import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';
import { MetadataService } from '../../services/metadata.service';
import { SearchService }  from '../../search/services/search.service';

import dayjs from 'dayjs';

/**
 * Component to submit feedback about a product.
 */
@Component({
	selector: 'product-feedback',
	templateUrl: './product-feedback.component.html',
	styleUrl: './product-feedback.component.css'
})
export class ProductFeedbackComponent implements OnInit {
	@Input() product: any;

	LOCALIZATION: any;
	Object = Object;

	metadata: { [key: string]: any } = {};
	comment: string = '';
	dateFormatDisplay: string = 'MM/DD/YY';
	submitting: boolean = false;

	constructor(
		private ngbmodalService: NgbActiveModal,
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private metadataService: MetadataService,
		private searchService: SearchService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		
		let dateTypeProperty = this.userService.user.properties.awpropertyObjectList.find((x: any) => { return x.name === "USER_INTERFACE_DATE_TYPE" });
		this.dateFormatDisplay = dateTypeProperty?.value || 'MM/DD/YY';		

		this.loadRecord();
	}

	/**
	 * Loads the product metadata.
	 */
	private loadRecord(): void {
		this.searchService.getRecord(this.product.id).then(
			(response: any) => {
				this.processMetadata(response);
			},
			(err: any) => {
				console.error("Failed to load product metadata", err);
				this.alertsService.error({
					message: "Failed to retrieve metadata for this document."
				});
			}
		);
	}
	
	private processMetadata(record: any) {
		let productHash = record["csw:GetRecordByIdResponse"].iStoreRecord;
		let productInfo: { [key: string]: any } = {};
		let validFields = this.userService.user.properties.awfieldObjectList.filter((x: any) => { return x.isAvailable && x.isMetadata });

		for (let p = 0; p < validFields.length; p++) {
			let field = validFields[p];

			if (!productHash[field.name]) {
				continue;
			}

			productInfo[field.displayName] = {
				label: field.displayName,
				value: productHash[field.name],
				maxLength: (field.isLink ? -1 : 220),
				links: null,
				name: field.name
			};

			productInfo[field.displayName].cleanedValue = this.metadataService.cleanValue(productInfo[field.displayName].value);
			productInfo[field.displayName].isValidCollection =
				this.metadataService.isValidFieldCollectionValue(productInfo[field.displayName].name, productInfo[field.displayName].cleanedValue);

			if (field.type == "DATE") {
				productInfo[field.displayName].value = dayjs(productInfo[field.displayName].value).format(this.dateFormatDisplay);
			}

			if (field.name == "requires") {
				productInfo[field.displayName].warning = true;
			}

			if (field.isLink) {
				productInfo[field.displayName].links = this.metadataService.linksFromString(productHash[field.name], field.name);
			} else {
				if (productInfo[field.displayName].value) {
					productInfo[field.displayName].value = productInfo[field.displayName].value.replace(/; /g, ';').replace(/;/g, '; ');
				}
			}
		}

		this.metadata = productInfo;
	}	

	/**
	 * Submits comments for the product.
	 */
	submitFeedback(): void {
		this.submitting = true;

		let baseUrl = window.location.origin;
		let link = baseUrl + '/s?v=L&a=c&criteria=' + encodeURIComponent("lb_document_id=" + this.product.id);

		let feedback = {
			comments: this.comment,
			username: this.userService.user.username,
			productlink: link,
			images: []
		};

		this.productService.reportFeedback(this.product.id, feedback).then(
			(response: any) => {
				this.submitting = false;
				this.alertsService.success({
					message: "Your feedback was submitted, thank you!"
				});
				this.close();
			},
			() => {
				this.submitting = false;
				this.alertsService.error({
					message: "Error submitting feedback."
				});
			}
		);
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
